import React from 'react';

const options = [
  { id: 'recent', label: 'Recent' },
  { id: '5y', label: '5 Years' },
  { id: '10y', label: '10 Years' },
  { id: 'all', label: 'All Years' }
];

function HistoryControls({ historyWindow, onChange, availableYears }) {
  const availabilityLabel = availableYears > 0
    ? availableYears + ' years available'
    : 'No history available';
  const currentIndex = Math.max(options.findIndex((option) => option.id === historyWindow), 0);

  return (
    <div className="history-controls">
      <div className="history-controls-label">Time Range</div>
      <div className="history-slider-wrap">
        <div className="history-slider-shell">
          <input
            type="range"
            min="0"
            max={options.length - 1}
            step="1"
            value={currentIndex}
            className="history-slider-input"
            aria-label="Time range"
            onChange={(event) => onChange(options[parseInt(event.target.value, 10)].id)} />
          <div className="history-slider-track">
            <div
              className="history-slider-fill"
              style={{ width: (currentIndex / (options.length - 1)) * 100 + '%' }} />
          </div>
          <div className="history-slider-stops">
            {options.map((option, index) => (
              <button
                key={option.id}
                type="button"
                className={historyWindow === option.id ? 'history-slider-stop active' : 'history-slider-stop'}
                onClick={() => onChange(option.id)}>
                <span className="history-slider-dot" />
                <span className="history-slider-text">{option.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="history-controls-meta">{availabilityLabel}</div>
    </div>
  );
}

export default HistoryControls;
